// extracted by mini-css-extract-plugin
module.exports = {"contacts":"components_contacts__3rE_0","ant-btn-link":"components_ant-btn-link__1lsk_","ant-btn":"components_ant-btn__1hZmk"};